import { UPDATE_LOADING } from "./types";

export const updateLoading = (loadingState) => ({
  type: UPDATE_LOADING,
  payload: loadingState,
});
